<template>
	<div
		ref="viewport"
		class="relative overflow-hidden"
		:class="{'touch-none': isZoomed}"
	>
		<div
			ref="content"
			:style="styles"
			class="[&.leaflet-zoom-suppress-clicks_*]:pointer-events-none"
			:class="{
				'touch-none': isZoomed,
				'[&_*]:pointer-events-none': isZoomed,
				'[&_.leaflet-zoom-exclude_*]:pointer-events-auto': isZoomed,
			}"
		>
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
	import {useMediaQuery} from '@vueuse/core';
	import useTailwindBreakpoints from '~/composables/useTailwindBreakpoints';
	import {useLeafletZoom} from '~/composables/useLeafletZoom';

	const viewport = useTemplateRef<HTMLElement>('viewport');
	const content = useTemplateRef<HTMLElement>('content');
	const isMobileViewport = useTailwindBreakpoints().smaller('lg');
	const isTouchDevice = useMediaQuery('(hover: none) and (pointer: coarse)');
	const isZoomGesturesEnabled = computed(() => isMobileViewport.value && isTouchDevice.value);

	const {reset, isZoomed, styles} = useLeafletZoom(content, viewport, isZoomGesturesEnabled);

	defineExpose({reset});
</script>
